import { Controller } from '@hotwired/stimulus';
import typeahead from 'typeahead.js';


export default class extends Controller {
  
  static targets = ["query", "channelId","selectedChannelName"];
  
  initialize(){
    this.boundHandleSelect = this.handleSelect.bind(this)
    this.boundHandleChange = this.handleChange.bind(this)
  }

  connect() {
    console.log(`${this.identifier} is connected.`)
    this.initTypeahead()
    $(this.element).on('typeahead:select', this.boundHandleSelect)
    $(this.element).on('typeahead:cursorchange', this.boundHandleSelect)
    $(this.queryTarget).on('typeahead:change', this.boundHandleChange)
  }
  disconnect(){
    $(this.element).off('typeahead:select')
  }

  handleSelect(ev,value){
    if(value){
      console.log(`${this.identifier}#handleSelect() -> ${value.id}/${value.name}`)
      $(this.channelIdTarget).val(value.id)
      if(this.hasSelectedChannelNameTarget){
        $(this.selectedChannelNameTarget).val(value.name)

      }
    }
    ev.stopImmediatePropagation()
  }

  handleChange(ev,value){
    // check if the user has changed manually the inst. name
    if(this.hasSelectedChannelNameTarget){
      let selectedName =  $(this.selectedChannelNameTarget).val() 
      if(value != selectedName){
        console.log(`typed name (${value}) is different than the selected name (${selectedName}). reset the channel id`)
        $(this.channelIdTarget).val("")
        $(this.selectedChannelNameTarget).val("")
      }
    }
  }


  initTypeahead(){
    $(this.queryTarget).typeahead({
      hint: false,
      highlight: true,
      minLength: 1
      },{
      name: 'channels',
      limit: 20,
      display: 'name',
      source: this.getChannels(),
      templates: {
        suggestion: (channel) =>  {
          return `<div>${channel.name}</div>`
        }
      }
    });
  }
 
  getChannels(){
    return new Bloodhound({
      datumTokenizer: Bloodhound.tokenizers.obj.whitespace('name'),
      queryTokenizer: Bloodhound.tokenizers.whitespace,
      remote: {
        url: '/channels/autocomplete?q=%QUERY',
        wildcard: '%QUERY',
      }
    });

  }
}